<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ventas</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="handleCampusChange"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  size="sm"
                  id="init"
                  v-model="filter.init"
                  :max="hoy"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Hasta"
                  type="date"
                  aria-label="shift_date"
                  id="end"
                  size="sm"
                  v-model="filter.end"
                  :max="hoy"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CButton
                  type="button"
                  color="primary"
                  class="w-100"
                  size="sm"
                  @click="mtd_data"
                >
                  <i class="fas fa-search"></i> Buscar
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper
          v-if="data.length>0"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          :items="data"
          small
          fixed
          caption="Historial de movimientos por sede"
          icon="fas fa-building"
          @mtdBack="mtdBack"
          :size="'md'"
          :actions="false"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import CTableWrapper from "../../../components/shared/datatable/Table.vue";

const fields = [
  { key: "id", label: "id", _style: "width:1%" },
  { key: "name", label: "Producto", _style: "width:10%;" },
  { key: "sales", label: "Ventas", _style: "width:10%;" },
  { key: "purchase", label: "Compras", _style: "width:10%;" },
];
export default {
  components:{CTableWrapper},
  data() {
    return {
      campu_id: null,
      data: [],
      fields,
      data_campus: [],
      data_sale_products: [],
      hoy:null,
      filter: {
        init: null,
        end: null,
      },
    };
  },
  created() {
    this.getCampus();
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.hoy = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
  },
  methods: {
    ...mapActions(["get", "post"]),
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });
        }
      });
    },
    handleCampusChange() {
      this.showSalesTable = false;
      this.showCampusSummary = false;
    },
    mtd_data: function () {
      if (this.campu_id >0) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/report/product/campu/" +
            this.campu_id+"/"+
            this.filter.init+"/"+this.filter.end,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.statusCode == 200) {
            // console.log(response.data);
            this.data = response.data
          }
        });
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>